export default "__VITE_ASSET__7neZSVjz__"